/* unplugin-vue-components disabled */import { render } from "./MainHead.vue?vue&type=template&id=d22066d2&scoped=true"
import script from "./MainHead.vue?vue&type=script&lang=js"
export * from "./MainHead.vue?vue&type=script&lang=js"

import "./MainHead.vue?vue&type=style&index=0&id=d22066d2&scoped=true&lang=css"

import exportComponent from "D:\\WorkPlace\\官网\\html-bcepd-project-website-official-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d22066d2"]])

export default __exports__